import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import axios from "axios";

class   ShoolfeeInvoice extends Component{
 
    state = {
        isModal : true,
        check : false,
        schoolfee : null,
    }

    async getSchoolfee(){
        var schoolfee = await axios.get("schoolfees/"+this.props.formData);
        if(schoolfee.status === 200)
        {
            this.setState({
                schoolfee : schoolfee.data
            })
        }
    }

    edit=()=>  {
        this.getSchoolfee()
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }
    
    Print_ = () =>{
        let invoices = window.open("", "_blank", "width=600,height=300")
        let Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']
        let text =  `${ this.state.schoolfee?.student?.sectionclass?.section?.establishment?.name  }\n`
        text += `_________________\n`
        if(this.state.schoolfee?.student?.sectionclass?.section?.establishment?.tax_center){
            text +=  `${ this.state.schoolfee?.student?.sectionclass?.section?.establishment?.tax_center || ''  }\n`
            // text += `.................\n\n`
        }
        text += `Adress : ${ this.state.schoolfee?.student?.sectionclass?.section?.establishment?.other_adress }\n`
        text += `Télé : ${ this.state.schoolfee?.student?.sectionclass?.section?.establishment?.tel }\n`
        // text += `Email : ${ this.state.schoolfee?.student?.sectionclass?.section?.establishment?.email }\n`
        text += `.................\n\n`
        text += `Matr. ID : ${ this.state.schoolfee?.student?.matricule }\n`
        text += `Elève : ${ (this.state.schoolfee?.student?.user?.last_name || '') } ${ (this.state.schoolfee?.student?.user?.family_name || '') } ${ (this.state.schoolfee?.student?.user?.first_name || '') }\n`
        // text += `Parent : ${ (this.state.schoolfee?.student?.user?.user?.last_name  || '') } ${ (this.state.schoolfee?.student?.user?.user?.family_name  || '') } ${ (this.state.schoolfee?.student?.user?.user?.first_name  || '') }\n`
        // text += `Télé : ${ (this.state.schoolfee?.student?.user?.user?.tel  || '') }\n`
        text += `_________________\n`
        text += ` \t  RECU N°. ${ this.state.schoolfee?.invoice }\n \n`
        
        text += `Année scolaire : ${ this.state.schoolfee?.year?.year }\n`
        // text += `Section/option : ${ this.state.schoolfee?.student?.sectionclass?.section?.entitled_section }\n`
        text += `Classe : ${ this.state.schoolfee?.student?.sectionclass?.class?.short_entitled_class } ${ this.state.schoolfee?.student?.sectionclass?.title} ${ this.state.schoolfee?.student?.sectionclass?.section?.short_entitled_section }\n\n`

        text += `La somme de : ${ this.state.schoolfee?.pay_mount + "" + this.state.schoolfee?.sectionschoolfeecategory?.currency }\n`
        text += `Motif : ${ this.state.schoolfee?.sectionschoolfeecategory?.schoolfeecategory?.category }  ${ (this.state.schoolfee?.sectionschoolfeecategory?.transport?.axe || "")}\n`
        text += `Echéance : ${  this.state.schoolfee?.trimesectschool?.trimester?.short_trimester || this.state.schoolfee?.month?.month }\n`
        // text += `Payé le : ${ new Date(this.state.schoolfee?.createdAt)?.getDate() } ${ Months[new Date(this.state.schoolfee?.createdAt)?.getMonth()]} ${ new Date(this.state.schoolfee?.createdAt)?.getFullYear() } ${ new Date(this.state.schoolfee?.createdAt)?.getHours() }h:${ new Date(this.state.schoolfee?.createdAt)?.getMinutes() }\n`
        text += this.state.schoolfee?.remaining_amount > 0 ? `Dette restante du ${  this.state.schoolfee?.trimesectschool?.trimester?.short_trimester || this.state.schoolfee?.month?.month } : ${ this.state.schoolfee?.remaining_amount + "" + this.state.schoolfee?.sectionschoolfeecategory?.currency}\n` : ``
        text += this.state.schoolfee?.dette > 0 ? `Dette totale: ${ this.state.schoolfee?.dette + "" + this.state.schoolfee?.sectionschoolfeecategory?.currency}\n` : ``
            
        text += `------------------\n`
        text += `Par : ${ (this.state.schoolfee?.staff?.user?.last_name  || '') } ${ (this.state.schoolfee?.staff?.user?.family_name  || '') }\n`
        
        // text += `Merci et bienvenue encore\n\t\n`
        text += `Print ${ new Date(this.state.schoolfee?.createdAt)?.toLocaleDateString("en-GB") } ${ new Date()?.getHours() }h:${ new Date()?.getMinutes() }`
        text += `\n©By Evive Digital\n\n`
        
        invoices.document.write(`<pre>${ text }</pre>`)
        invoices.document.close()
        invoices.print()
    }

    checkbox = () => {
        this.setState({
            check: !this.state.check
        }); 
    }

    render(){
        
        var profile = JSON.parse(localStorage.getItem('profile'))
        const schoolfee = this.state.schoolfee;
        const establishment = profile?.profile?.establishment || {};
        const studentName = schoolfee ? `${ schoolfee.student.user.last_name } ${schoolfee.student.user.family_name ? schoolfee.student.user.family_name : "" } ${schoolfee.student.user.first_name ? schoolfee.student.user.first_name : "" }` : "";
        const className = schoolfee ? `${schoolfee.student.sectionclass.class.short_entitled_class} ${schoolfee.student.sectionclass.title}` : "";
        const period = schoolfee?.trimesectschool?.trimester?.short_trimester || schoolfee?.month?.month;
        const currency = schoolfee?.sectionschoolfeecategory?.currency || "";
        const category = schoolfee?.sectionschoolfeecategory?.schoolfeecategory?.category || "";
        const transport = schoolfee?.sectionschoolfeecategory?.transport?.axe || "";
        const paidDate = schoolfee ? new Date(schoolfee.createdAt)?.toLocaleDateString("en-GB") : "";
        const isCompact = this.state.check;
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="schoolfee-invoice-dialog"
                contentClassName="schoolfee-invoice-modal"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header className="schoolfee-invoice-header">
                    <div className="schoolfee-invoice-title">
                        <span><FeatherIcon icon="file-text" size="20" /></span>
                        <div>
                            <small>Recu imprimable</small>
                            <Modal.Title>Recu de paiement</Modal.Title>
                        </div>
                    </div>
                    {schoolfee != null && <b>Recu No {schoolfee.invoice}</b>}
                </Modal.Header>
                {
                    schoolfee != null &&(
                        <Modal.Body className="schoolfee-invoice-body">
                            <div className={isCompact ? "schoolfee-invoice-receipt is-compact" : "schoolfee-invoice-receipt"} ref={el => (this.componentRef = el)}>
                                <div className="schoolfee-invoice-receipt__head">
                                    {establishment.logo ? <img src={establishment.logo} alt="" /> : null}
                                    <div>
                                        <strong>{ establishment.name}</strong>
                                        <span>{ establishment.city}</span>
                                        <span>Tel : { establishment.tel} {establishment.email ? ` | Email : ${establishment.email}` : ""}</span>
                                    </div>
                                </div>

                                <div className="schoolfee-invoice-receipt__title">
                                    <span>Recu No</span>
                                    <strong>{schoolfee.invoice}</strong>
                                </div>

                                <div className="schoolfee-invoice-receipt__meta">
                                    <div><span>Annee scolaire</span><strong>{schoolfee.year.year}</strong></div>
                                    <div><span>Classe</span><strong>{className}</strong></div>
                                    <div><span>Section/option</span><strong>{schoolfee.student.sectionclass.section.entitled_section}</strong></div>
                                    <div><span>Date de paiement</span><strong>{paidDate}</strong></div>
                                </div>

                                <div className="schoolfee-invoice-receipt__text">
                                    <p>Recu de <strong>{studentName}</strong></p>
                                    <p>La somme de <strong>{ schoolfee.pay_mount + "" + currency}</strong></p>
                                    {schoolfee?.remaining_amount > 0 ? <p>Dette {period} : <strong>{ schoolfee?.remaining_amount + "" + currency}</strong></p>: null}
                                    {schoolfee?.dette > 0 ? <p>Dette totale : <strong>{ schoolfee?.dette + "" + currency}</strong></p>: null}
                                    <p>Motif : <strong>{category + " " + transport +" echeance de " + period}</strong></p>
                                </div>

                                <div className="schoolfee-invoice-receipt__sign">
                                    <span>Pour l'etablissement</span>
                                    <strong>{ schoolfee.staff.user.last_name+ " " + schoolfee.staff.user.first_name}</strong>
                                    <small>{ establishment.city}, le { new Date()?.toLocaleDateString("en-GB") }</small>
                                </div>
                            </div>
                        </Modal.Body>
                    )
                }
                    <Modal.Footer className="schoolfee-invoice-footer">
                        <label className="schoolfee-invoice-check" htmlFor="check"><input type={"checkbox"} onClick={() => this.checkbox()} id="check" /> Format compact</label>
                        <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <button onClick={() => this.Print_()} className="btn btn-outline-primary btn-sm"><FeatherIcon icon="printer" size="20"></FeatherIcon> POS</button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </Modal.Footer>
            </Modal>
            

            {/* <ParentfamilyForm 
                isModal={this.state.isModal} 
                formData={{}} 
                showModal={this.showModal}
            /> */}
        </div>
        )
    }
}
export default ShoolfeeInvoice;


